// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"SearchPage__ellipsis__1-IYA","flex-child-ellipsis":"SearchPage__flex-child-ellipsis__2PLUK","multiplayer-cursor":"SearchPage__multiplayer-cursor__3XDhU"};